import { createFileRoute } from "@tanstack/react-router";

import { GroupAdminMembersPanel } from "@/components/groups/group-admin";
import { useGroupRouteData } from "@/hooks/use-group-route-data";

export const Route = createFileRoute("/_authenticated/app/groups/$groupId/admin/members")({
  component: GroupAdminMembersTab,
});

function GroupAdminMembersTab() {
  const { groupId, isAdmin, group } = useGroupRouteData(Route.useParams().groupId);

  if (!group || !isAdmin) return null;

  return (
    <div className="mx-auto max-w-180">
      <GroupAdminMembersPanel
        groupId={groupId}
        isGlobal={group.isGlobal}
        visibility={group.visibility ?? (group.isPrivate ? "secret" : "public")}
      />
    </div>
  );
}
